import React, { useState, useEffect } from 'react';
import '../../css/bootstrap.min.css';
import '../../css/feathericon.min.css';
import '../../css/font-awesome.min.css';
import '../../css/select2.min.css';
import '../../css/style.css';
import '../../css/admin-sidebar.css';
import axios from 'axios';
import logo from "../../../assets/img/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import AdminSidebar from '../Adminsidebar/AdminSidebar';

function AddVideos() {
    const [activeLink, setActiveLink] = useState(null);
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [videoUrl, setVideoUrl] = useState("");
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [videosPerPage, setVideosPerPage] = useState(6);
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL


    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const handleLinkClick = (link) => {
        setActiveLink(link);
    };

    useEffect(() => {
        fetchVideos();
    }, []);

    const fetchVideos = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/api/videos`);
            setVideos(response.data);
            setError('');
        } catch (err) {
            console.error("Error fetching videos:", err);
            setError("Error fetching videos: " + err.message);
            setVideos([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAddVideo = async (e) => {
        e.preventDefault();
        if (!videoUrl.trim()) {
            setError("Please enter a valid video URL.");
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/api/videos/add`, { videoUrl });
            setVideos((prevVideos) => [...prevVideos, response.data]);
            setVideoUrl("");
            setMessage("Video added successfully!");
            setError('');
            handleCloseAddModal();
            fetchVideos();
        } catch (err) {
            console.error("Error adding video:", err);
            setError("Failed to add video: " + err.message);
        }
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/api/videos/${id}`);
            fetchVideos();
            setMessage('Video deleted successfully');
        } catch (err) {
            console.error('Error deleting video:', err);
            setError('Error deleting video: ' + err.message);
        }
    };
     const handleShowAddModal = () => {
        setShowAddModal(true);
    };

    // Function to close the modal
    const handleCloseAddModal = () => {
        setShowAddModal(false);
        setVideoUrl('');  // Clear video URL on modal close
        setError('');
        setMessage('');
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    // Calculate indexes for pagination
    const indexOfLastVideo = currentPage * videosPerPage;
    const indexOfFirstVideo = indexOfLastVideo - videosPerPage;

    const handleVideosPerPageChange = (e) => {
        setVideosPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    const filteredVideos = videos.filter(video =>
        video.videoUrl.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const currentVideos = filteredVideos.slice(indexOfFirstVideo, indexOfLastVideo);

    const paginate = pageNumber => setCurrentPage(pageNumber);

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredVideos.length / videosPerPage); i++) {
        pageNumbers.push(i);
    }

    const getEmbeddedURL = (url) => {
        if (url.includes("youtube.com")) {
            return url.replace("watch?v=", "embed/");
        } else if (url.includes("youtu.be")) {
            return `https://www.youtube.com/embed/${url.split('/').pop()}`;
        }
        return url;
    };

    return (
        <div className="main-wrapper">
            <div className="hitkari-main-wrapper">
                <AdminSidebar/>

                {/* Main Content */}
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title">Videos</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/dash">Dashboard</a></li>
                                        <li className="breadcrumb-item active">Videos</li>
                                    </ul>
                                </div>
                                <div className="col-auto">
                             <button type="button" className="btn btn-primary" onClick={handleShowAddModal}>
                             <i className="fas fa-plus"></i> Add Video
                            </button>
                        </div>
                            </div>
                        </div>

                        {/* Messages */}
                        {message && <div className="alert alert-success">{message}</div>}
                        {error && <div className="alert alert-danger">{error}</div>}

                       

                        
                          <br/>

                        {/* Video List */}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                       {/* Search Input */}
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search videos url..."
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                                  <div className="col-12 d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <label>Items per page:</label>
                            <select
                                className="form-control"
                                value={videosPerPage}
                                onChange={(e) => setVideosPerPage(Number(e.target.value))}
                            >
                                <option value="3">3</option>
                                <option value="6">6</option>
                                <option value="9">9</option>
                                <option value="50">50</option>

                            </select>
                        </div>
                         {/* Pagination */}
                                <nav aria-label="Videos pagination">
                                    <ul className="pagination justify-content-center">
                                       
                                        {pageNumbers.map(number => (
                                        <li key={number} className="page-item">
                                            <button onClick={() => paginate(number)} className="page-link">
                                                {number}
                                            </button>
                                        </li>
                                    ))}
                                    </ul>
                                </nav>
                             </div>
                             
                        </div>
                                        {loading ? (
                                            <p>Loading...</p>
                                        ) : error ? (
                                            <p>{error}</p>
                                        ) : (
                                            <div className="row">
                                                {currentVideos.map((video) => (
                                                    <div className="col-md-4" key={video._id}>
                                                        <div className="card">
                                                            {/* Video Player */}
                                                            {video.videoUrl.includes("youtube.com") || video.videoUrl.includes("youtu.be") ? (
                                                                <iframe
                                                                    width="100%"
                                                                    height="200"
                                                                    src={getEmbeddedURL(video.videoUrl)}
                                                                    title="YouTube Video"
                                                                    frameBorder="0"
                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                    allowFullScreen
                                                                ></iframe>
                                                            ) : (
                                                                <video width="100%" controls>
                                                                    <source src={video.videoUrl} type="video/mp4" />
                                                                    Your browser does not support the video tag.
                                                                </video>
                                                            )}

                                                            {/* Delete Button */}
                                                            <div className="card-body">
                                                                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(video._id)}>
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                </div>
            </div>
           {/* Add Video Modal */}
            {showAddModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="addVideoModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="addVideoModalLabel">Add New Video</h5>
                                <button type="button" className="close" onClick={handleCloseAddModal} aria-label="Close">
                                    <span aria-hidden="true"><FontAwesomeIcon icon={faTimes} /></span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleAddVideo}>
                                    <div className="form-group">
                                        <label>Video URL:</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={videoUrl}
                                            onChange={(e) => setVideoUrl(e.target.value)}
                                            placeholder="Enter video URL (YouTube or direct MP4)"
                                        />
                                    </div>
                                     {message && <div className="alert alert-success">{message}</div>}
                                     {error && <div className="alert alert-danger">{error}</div>}
                                    <button type="submit" className="btn btn-primary">Add Video</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
         </div>
    );
}

export default AddVideos;